<template>
    <nav class='main' :class='{show: showMenu}'>
      <section class='archive' v-if='categorypages'>
        <router-link @click.native='showMenu=0' :to='pathName(page?.url)' v-for="page in categorypages"  :key="page?.id" v-html="page?.title" />
      </section>
      <section v-if='otherpages'>
        <router-link @click.native='showMenu=0' :to='pathName(page?.url)' v-for="page in otherpages"  :key="page?.id" v-html="page?.title" />
      </section>
    </nav>
</template>

<script setup>
  import { useStore } from '@/KQL.js'
  import { yamlToObject, pagesFromPaths, pathName } from '@/utils'
  import { composables } from '@/composables'
  const showMenu = composables().showMenu;
  const kql = useStore();
  const categoryids = computed(()=> yamlToArray(kql.site.content?.categoryparents));
  const categorypages = computed(()=> categoryids.value.map(item => pageFromPath(item, kql.pages)));
  const otherids = computed(()=> yamlToArray(kql.site.content?.other));
  const otherpages = computed(()=> otherids.value.map(item => pageFromPath(item, kql.pages)));
</script>

<style scoped>
  nav.main {
    position: fixed;
    display: flex;
    flex-direction: row;
    font-size: var(--main-heading-size);
    font-family: var(--serif);
    line-height: 1em;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    z-index: 100;
  }

  nav.main section {
    display: flex;
    flex-direction: column;
    min-width: 24rem;
  }


  nav.main section a {
    transition: opacity 0.2s ease-in-out;
    /* Safari optimization for smooth animations */
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
  }

  nav.main section a:hover {
    opacity: 0.5;
  }

  nav.main section a:active {
    opacity: 0.3;
  }

  nav.main section.archive::before {
    content: 'Archive:';
    opacity: 0.5;
  }

  nav.main section.archive::before {
  }


  nav.main {
    top: var(--header-padding);
    right: var(--offset);
    opacity: 0;
    pointer-events: none;
    transition: opacity 150ms ease-out 0ms;
    user-select: none;
    /* Safari optimization */
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    will-change: opacity;
  }

  nav.main.show {
    opacity: 1;
    pointer-events: all;
    transition: opacity 150ms ease-out 150ms;
  }

  @media (max-width: 1080px) {
    nav.main {
      right: 0;
      left: 0;
      margin: auto;
      flex-direction: column-reverse;
      width: var(--main-width-narrow);
      margin-top: 13rem;
    }

    nav.main section {
      margin-bottom: 3rem;
      width: 100%;
    }
  }
</style>
